// extracted by mini-css-extract-plugin
module.exports = {"questionArea":"Assessment_questionArea___4lx9","sectionHeading":"Assessment_sectionHeading__BJdwz","BasicDetailsEdit":"Assessment_BasicDetailsEdit__FoUwL"};